module.exports = __webpack_public_path__ + "img/icono_escenario_act.d8f91aa8.png";